import { IPopup } from "./popup";
import { getUrlWithoutQueryString } from "./common";
import HttpClient from "./http-client";

export default class ProductColorVariants {
    private popup: IPopup;
    private isOpen: boolean;

    constructor(popup: IPopup) {
        this.popup = popup;
    }

    public show(closeOnSelection: boolean, selectionHandler: (productUrl: string) => void): void {
        if (this.isOpen) {
            return;
        }

        const url = `${getUrlWithoutQueryString()}?viewComponent=AllColorsVariants`;
        new HttpClient().fetch(url)
            .then(response => response.text())
            .then(body => {
                this.popup.open(body)
                this.isOpen = true;
                this.initPopup(closeOnSelection, selectionHandler);
            });
    }

    private initPopup(closeOnSelection: boolean, selectionHandler: (productUrl: string) => void) {
        const baseElement = document.querySelector('[data-component="AllColorsVariants"]');
        baseElement.querySelectorAll('[data-component-part="product-select-link"]')
            .forEach(link => this.addProductSelectionListener(link, closeOnSelection, selectionHandler));
    }

    private addProductSelectionListener(link: Element, closeOnSelection: boolean, selectionHandler: (productUrl: string) => void) {
        link.addEventListener('click', (evt) => this.selectProduct(evt, closeOnSelection, selectionHandler))
    }

    private selectProduct(evt: Event, closeOnSelection: boolean, selectionHandler: (productUrl: string) => void) {
        evt.preventDefault();
        const url = (<HTMLElement>evt.currentTarget).getAttribute('data-product-url');
        if (!url) {
            return;
        }
        selectionHandler(url);
        if (closeOnSelection) {
            this.close();
        }
    }

    public close(): void {
        this.popup.close();
    }
}
